import React from 'react';

interface IProps {
  id: number;
  text: string;
  fontSize: string;
  points: Julius.Website.SectionPointViewModel[];
  onClick?: (sectionID: number) => void;
  isAvailable: boolean;
  width: number;
}

const SectionText: React.SFC<IProps> = ({
  points,
  onClick,
  fontSize,
  text,
  id,
  isAvailable,
  width,
}) => {
  const getArea = () => {
    let i;
    let j;
    let point1;
    let point2;
    let area = 0;
  
    const { length } = points;

    for (i = 0, j = length - 1; i < length; j = i, i += 1) {
      point1 = points[i];
      point2 = points[j];
      area += point1.x * point2.y;
      area -= point1.y * point2.x;
    }
    area /= 2;
    return area;
  }
  
  const getCenterPoint = () => {
    let x = 0;
    let y = 0;
    const { length } = points;
    
    if (length === 2) {
      x = (points[0].x + points[1].x) / 2;
      y = (points[0].y + points[1].y) / 2;
      return { x, y };
    }

    let i;
    let j;
    let f;
  
    for (i = 0, j = length - 1; i < length; j = i, i += 1) {
      const point1 = points[i];
      const point2 = points[j];
      f = point1.x * point2.y - point2.x * point1.y;
      x += (point1.x + point2.x) * f;
      y += (point1.y + point2.y) * f;
    }
  
    f = getArea() * 6;
    return { x: x / f, y: y / f };
  }

  const center = getCenterPoint();

  if (isNaN(center.x) || isNaN(center.y) || !text) {
    return null;
  }

  const nearBorderThreshold = 1/5;
  const isNearBorder = center.x < width * nearBorderThreshold ||
    center.x > width * (1 - nearBorderThreshold);
  const writingMode = isNearBorder ? "vertical-lr" : "horizontal-tb";
  const cursor = isAvailable ? "pointer" : "default";

  return (
    <text
      dominantBaseline="middle"
      textAnchor="middle"
      x={ center.x }
      y={ center.y }
      onClick={ isAvailable ? () => onClick(id) : undefined }
      style={ { 
        cursor,
        fontSize, 
        fontWeight: "bold",
        zIndex: 10,
        writingMode,
      } }
    >
      { text }
    </text>
  );
};

export default SectionText;


// WEBPACK FOOTER //
// ./src/components/PickSeatManually/SectionOverview/SectionText.tsx